import React, { useState, useEffect, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ButtonGroup from "./ButtonGroup";
import { UserContext } from "contexts/";
import SkeletonLoader from "components/SkeletonLoader";

export default function LoginButton(props) {
	const { fetchingUser } = useContext(UserContext);
	const [redirectLink, setRedirectLink] = useState(false);
	const { loginWithRedirect, user, isAuthenticated, isLoading } = useAuth0();

	useEffect(() => {
		setRedirectLink(window.location.href);
	}, [typeof window !== "undefined" ? window.location.href : ""]);

	return (
		<ButtonGroup
			button1Variant={props.variant || "yellow"}
			button1Children={fetchingUser ? <SkeletonLoader baseColor={props.variant || "yellow"} /> : <></>}
			alignButtons={"center"}
			fontSize={props.fontSize || 20}
			btn1={{
				text: fetchingUser ? "" : props.text || "Log In",
			}}
			onClick={(e) => {
				e.preventDefault();

				loginWithRedirect({ appState: { prevPath: redirectLink } });
			}}
			additionalClasses={props.additionalClasses || ""}
			groupClasses={props.groupClasses || ""}
			buttonWidth={props.buttonWidth || ""}
		/>
	);
}
